<template>
  <div class="columns is-multiline mb-30" v-if="recom">
    <div
      v-for="(panneau, index) in panneaux"
      :key="index"
      class="column is-6-desktop is-4-widescreen is-mobile">
      <div class="card is-relative is-height-100p">
        <div class="card-image pointer">
          <figure class="card-img-panneau">

            <img class="img-panneau" :src="getImg(panneau.urlLogo)">

            <div class="bande-info" @click="affichePanneau(index)">
              <div class="level has-text-weight-bold is-mobile">
                <div class="level-left is-size-7">
                  {{ getPeriode(panneau) }}
                </div>
              </div>
            </div>

          </figure>

        </div>

        <div
          @click="affichePanneau(index)"
          class="card-content pa-20 mb-40 pointer">
          <div class="columns is-multiline mb-0 is-mobile">

            <div class="column is-12" v-if="panneau.adresseCommerciale">
              <div class="level is-mobile">
                <div class="level-left">
                  <div class="level-item">
                    <div class="num-panneau has-text-centered">
                      <span class="has-text-white is-size-14px">{{ panneau.num }}</span>
                    </div>
                  </div>
                  <div class="level-item">
                    <div class="width-libelle">
                      <p class="has-text-default is-size-10px"> Adresse </p>
                      <p class="has-text-grid-1 has-text-weight-bold is-size-14px mb-0 truncate-libelle">
                        {{ panneau.adresseCommerciale }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12" v-if="panneau.referencePanneau">
              <div class="media">
                <b-icon
                  icon="barcode"
                  size="is-medium"
                  class="media-left"
                  type="is-grid-5">
                </b-icon>
                <div class="media-content is-size-10px has-text-default">
                  <label class="has-text-default">
                    Référence
                  </label>
                  <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
                    {{panneau.referencePanneau}}
                  </p>
                </div>
              </div>
            </div>

            <div class="column is-6">
              <div class="media">
                <b-icon
                  icon="vector-intersection"
                  size="is-medium"
                  class="media-left"
                  type="is-grid-5">
                </b-icon>
                <div class="media-content is-size-10px has-text-default">
                  <label class="has-text-default">
                    Format
                  </label>
                  <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
                    {{panneau.format}}
                  </p>
                </div>
              </div>
            </div>

            <div class="column is-6" v-if="panneau.materiel">
              <div class="media">
                <b-icon
                  icon="package-variant-closed"
                  size="is-medium"
                  class="media-left"
                  type="is-grid-5">
                </b-icon>
                <div class="media-content is-size-10px has-text-default">
                  <label class="has-text-default">
                    Matériel
                  </label>
                  <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
                    {{panneau.materiel}}
                  </p>
                </div>
              </div>
            </div>

            <div class="column is-6">
              <div class="media">
                <b-icon
                  icon="sign-text"
                  size="is-medium"
                  class="media-left"
                  type="is-grid-5">
                </b-icon>
                <div class="media-content is-size-10px has-text-default">
                  <label class="has-text-default">
                    Catégorie
                  </label>
                  <p v-if="panneau.categorie"
										class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
                    {{panneau.categorie.libelle}}
                  </p>
                </div>
              </div>
            </div>

            <div class="column is-6">
              <div class="media">
                <b-icon
                  icon="sign-text"
                  size="is-medium"
                  class="media-left"
                  type="is-grid-5">
                </b-icon>
                <div class="media-content is-size-10px has-text-default">
                  <label class="has-text-default">
                    Régie
                  </label>
                  <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
                    {{panneau.regie}}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-40">
            <label v-if="panneau.commentaire" class="has-text-default is-size-10px">
              Argumentaire
            </label>
            <p v-if="panneau.commentaire" class="has-text-grid-1 is-size-14px pre-line-text">
              {{panneau.commentaire}}
            </p>
          </div>

        </div>

        <div class="card-footer card-footer__custum has-background-grid-5">
          <a class="card-footer-item pa-10" @click="affichePanneau(index)">
            <p class="is-size-14px has-text-white">
              Cliquer pour plus d’informations
            </p>
          </a>
        </div>

      </div>
    </div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <DetailPanneau
        v-if="detailPanneau"
        @close="detailPanneau = null"
        :detailPanneau="detailPanneau"
        :bg="bg" />
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatDate, getImg } from '@/services/general/general';
import DetailPanneau from '@/components/portail/blocProduits/DetailPanneau';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: {
    DetailPanneau,
  },
  data: () => ({
    detailPanneau: null,
    bg: false,
  }),
  computed: {
    ...Recommandation.mapGetters({
      recom: 'recom',
      panneaux: 'panneaux',
    }),
  },
  methods: {
    getImg: getImg,
    getPeriode(panneau) {
      return `Du ${formatDate(panneau.budgetGeneration.dateDebut)}
				au ${formatDate(panneau.budgetGeneration.dateFin)}`
    },
    affichePanneau(i) {
      this.detailPanneau = this.panneaux[i];
    },
  },
}
</script>
